const React = require('react');
const { FieldProvider } = require('./FieldContext');
const ManagedFieldsRenderer = require('./ManagedFieldsRenderer');

module.exports = function ManagedFormContainer(props) {

    const {
        controller = {},
        FieldsRenderer = ManagedFieldsRenderer,
        Renderer
    } = props;
    const {
        formConfig,
        formModel,
        inputRefs,
        instanceKey,
        methods,
        preferencesHandle,
        rendererProps
    } = controller;

    const renderFields = (renderOptions) => <FieldsRenderer {...renderOptions} />;

    return <FieldProvider
        formConfig={formConfig}
        formMethods={methods}
        formModel={formModel}
        inputRefs={inputRefs}
        preferencesHandle={preferencesHandle}
    >
        <Renderer
            key={instanceKey}
            {...rendererProps}
            renderFields={renderFields}
        />
    </FieldProvider>;
};
